import { store } from '@src/state/store';
import { getCurrentGame } from '@src/state/selectors/selector_game';
import { pushEventQueue } from '@src/state/slices/slice_game';

import { Game } from '@src/lib/types';

export default () => (data: any) => {
  // const game: Game | null = store.getState().game.games[data.gameId];
  // if (!game) throw new Error("[_drawFour] game not found in root state")
  // const player = game.players[data.playerindex];
  // console.log(data.gameId, game.gameId)
  // if (data.gameId == game.gameId) {
  //   console.log("GAME ENDED");
  //   store.dispatch(pushEventQueue({message: `${player.playerId} WON THE GAME!`, showToast: true, sound: "gameEnd"}));
  // }
};
